import React, { useState, useEffect } from 'react';

// Notistack
import { useSnackbar } from 'notistack';

// Material-UI
import { Grid, Button, Divider, Dialog, DialogContent, DialogActions } from '@material-ui/core';

// Services
import { updateSubscriptionType } from 'services/requests';
import { amountToSend } from 'services/helpers';
import useMediaQueries from 'services/media';

// Components
import Spinner from 'components/spinner';
import InputText from 'components/input-text';
import Title from 'components/title';
import InputFile from 'components/input-file';

// Messages
import messages from 'messages.json';

// --------------------------------------------------------------------------------------------- \\
// --------------------------------- UPDATE SUBSCRIPTION TYPE  --------------------------------- \\
// --------------------------------------------------------------------------------------------- \\

const UpdateSubscriptionType = ({ onClose, refetch, subscription_type }) => {
    const { enqueueSnackbar } = useSnackbar();
    const { mediaMD } = useMediaQueries();

    const [state, setState] = useState({
        loading: false,
        name: subscription_type?.name || '',
        price: subscription_type?.price ? (subscription_type.price / 100) : '',
        description: subscription_type?.description || '',
        uploaded_file: null,
    });

    function onUpdate() {
        if (state.name === '' || state.price === '') {
            enqueueSnackbar(messages['fields.required'], { variant: 'warning' });
        }
        else {
            const file = document.getElementById('upload-subscription-image').files[0];

            if (file) {
                setState({ ...state, loading: true, uploaded_file: file });
            }
            else {
                setState({ ...state, loading: true });
            }
        }
    }

    useEffect(() => {
        if (state.loading) {

            const formData = new FormData();
            formData.append('name', state.name);
            formData.append('price', amountToSend(state.price).toString());
            formData.append('description', state.description);

            if (state.uploaded_file) {
                formData.append('uploaded_file', state.uploaded_file);
            }

            updateSubscriptionType(subscription_type.id, formData).then(res => {
                if (res.status === 200) {
                    enqueueSnackbar(res.data.message, { variant: 'success' });
                    refetch();
                }
                else {
                    enqueueSnackbar(res, { variant: 'error' });
                    setState({ ...state, loading: false });
                }
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.loading]);

    return (
        <Dialog
            open
            fullWidth
            fullScreen={!mediaMD}
        >
            {state.loading ? (
                <Spinner />
            ) : (
                <>
                    <DialogContent style={{ paddingBottom: 20 }}>
                        <p className="dialog-title">
                            Mettre à jour un abonnement
                        </p>
                        {/* ---------------------- NAME ---------------------- */}
                        <Grid container alignItems="center">
                            <Grid item xs={12} sm={5}>
                                <Title required>
                                    Nom de l'abonnement
                                </Title>
                            </Grid>
                            <Grid item xs={12} sm={7}>
                                <InputText
                                    label="Nom de l'abonnement"
                                    type="text"
                                    value={state.name}
                                    onChange={e => setState({ ...state, name: e.target.value })}
                                />
                            </Grid>
                        </Grid>
                        {/* ---------------------- PRICE ---------------------- */}
                        <Grid
                            container alignItems="center"
                            style={{ marginTop: 12 }}
                        >
                            <Grid item xs={12} sm={5}>
                                <Title required>
                                    Prix TTC (€)
                                </Title>
                            </Grid>
                            <Grid item xs={12} sm={7}>
                                <InputText
                                    label="Prix TTC (€)"
                                    type="number"
                                    value={state.price}
                                    onChange={e => setState({ ...state, price: e.target.value })}
                                />
                            </Grid>
                        </Grid>
                        {/* ---------------------- IMAGE ---------------------- */}
                        <Grid
                            container alignItems="center"
                            style={{ marginTop: 12 }}
                        >
                            <Grid item xs={12} sm={5}>
                                <Title>
                                    Image de l'abonnement
                                </Title>
                                <br />
                                <em>
                                    dimension rectangle (300*500)
                                </em>
                            </Grid>
                            <Grid item xs={12} sm={7}>
                                <InputFile inputId="subscription-image" />
                            </Grid>
                        </Grid>
                        {/* ---------------------- DESCRIPTION ---------------------- */}
                        <div style={{ marginTop: 12 }}>
                            <Title>
                                Description longue
                            </Title>
                            <InputText
                                label="Description longue"
                                multiline
                                value={state.description}
                                onChange={e => setState({ ...state, description: e.target.value })}
                            />
                        </div>
                    </DialogContent>
                    <Divider />
                    <DialogActions style={{ justifyContent: 'space-between' }}>
                        <Button
                            onClick={onClose}
                            variant="contained"
                        >
                            Fermer
                        </Button>
                        <Button
                            onClick={onUpdate}
                            variant="contained"
                        >
                            Enregistrer
                        </Button>
                    </DialogActions>
                </>
            )}
        </Dialog>
    );
};

export default UpdateSubscriptionType;
